var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.381 0L71.5548 12.6381L86.5881 13.3905L87.3476 28.4214L99.9929 36.5881L93.1333 49.9881L100 63.381L87.3619 71.5548L86.6095 86.5881L71.5786 87.3476L63.4119 99.9929L50.0119 93.1333L36.619 100L28.4452 87.3619L13.4119 86.6095L12.6524 71.5786L0.00714291 63.4119L6.86667 50.0119L0 36.619L12.6381 28.4452L13.3905 13.4119L28.4214 12.6524L36.5881 0.00714291L49.9881 6.86667L63.381 0Z",
    fill: "#42A5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8001 67.2743L28.3311 51.81L33.3834 46.76L43.8763 57.2528L66.6572 35.1719L71.6287 40.3004L43.8001 67.2743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificado);
export default __webpack_public_path__ + "static/media/Verificado.39d8d34c.svg";
export { ForwardRef as ReactComponent };